import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "uv-enquiry-modal-content"
}
const _hoisted_2 = {
  key: 1,
  class: "uv-vehicle-modal-content"
}
const _hoisted_3 = {
  key: 2,
  class: "uv-info-modal-content"
}
const _hoisted_4 = {
  key: 3,
  class: "uv-info-modal-content"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { className: "uv-infomodal-tcimage" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/content/btn-toyotacertifiedadvantage-black.svg",
      alt: "Toyota Certified Advantage"
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "The Certified Pre-Owned Vehicle Program offers a range of benefits and comes with the backing of Australia's most trusted automotive brand, Toyota, so you know what you’re getting.This car is a Certified Pre-Owned Toyota and some of the benefits it comes with includes: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "A full service history "),
    /*#__PURE__*/_createElementVNode("li", null, "An independent CarHistory® background check "),
    /*#__PURE__*/_createElementVNode("li", null, "A statutory warranty where applicable + "),
    /*#__PURE__*/_createElementVNode("li", null, "90 point inspection by Toyota technicians "),
    /*#__PURE__*/_createElementVNode("li", null, "1 year of nationwide Toyota Roadside Assist *"),
    /*#__PURE__*/_createElementVNode("li", null, "Flexible finance and insurance options available ++")
  ]),
  /*#__PURE__*/_createElementVNode("div", { className: "uv-infomodal-disclaimers" }, [
    /*#__PURE__*/_createElementVNode("p", null, "+ Applicability of Statutory Warranty may vary for used vehicles sold in different States and Territories in Australia.You must check with your Toyota Dealer to determine what Statutory Warranty is applicable (if any). Any Statutory Warranty does not limit and may not necessarily exceed your right under the Competition and Consumer Act 2010. "),
    /*#__PURE__*/_createElementVNode("p", null, "* Terms and conditions apply.Roadside assist expired 12 months from the vehicle delivery date.Toyota Extra Care is administered by Toyota Finance, a division of Toyota Finance Australia Limited ABN 48 002 435 181, AFSL and Australian Credit Licence 392536. "),
    /*#__PURE__*/_createElementVNode("p", null, "++ Approved applicants only.Terms and conditions apply.Toyota Finance is a division of Toyota Finance Australia Limited.Toyota Insurance is issued by Toyota Finance Australia Limited ABN 48 002 435 181, AFSL and Australian Credit Licence 392536. ")
  ])
], -1)
const _hoisted_6 = [
  _hoisted_5
]

import { computed } from 'vue'; 
	import { useStore } from 'vuex';
	import VehicleModal from './VehicleModal.vue';
	import VehicleEnquiryForm from '@/components/forms/VehicleEnquiryForm.vue';
	import VehicleQuickLookDetail from '@/VehicleApp/VehicleQuickLookDetail.vue';
	import VehicleReserve from '@/VehicleApp/VehicleReserve.vue';
	import { ECtas } from '@/enums';
	import { IStoreState } from '@/types.d';

	
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	const store = useStore<IStoreState>();

	const showLocation = computed(() => store.state.showLocation);
	const isModalOpen = computed((): boolean => store.state.enquiryModal.isVisible);
	const showEnquiryForm = computed((): boolean => 
		store.state.enquiryModal.type == ECtas.enquireButton || 
		store.state.enquiryModal.type == ECtas.testDriveButton || 
		store.state.enquiryModal.type == ECtas.requestAVideoButton
	);
	const showQuickLookDetails = computed((): boolean => store.state.enquiryModal.type == ECtas.quickLook);
	const showCertifiedDetails = computed((): boolean => store.state.enquiryModal.type == ECtas.certifiedText);
	const showReserveDetails = computed((): boolean => store.state.enquiryModal.type == ECtas.reserveButton);

	const handleModalEnquiryPosted = (): void => {
		store.commit('resetEnquiryModal');
	}

return (_ctx: any,_cache: any) => {
  return (_unref(isModalOpen))
    ? (_openBlock(), _createBlock(VehicleModal, { key: 0 }, {
        default: _withCtx(() => [
          (_unref(showEnquiryForm))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(VehicleEnquiryForm, {
                  type: _unref(store).state.enquiryModal.type,
                  vehicle: _unref(store).state.enquiryModal.vehicle,
                  onPosted: handleModalEnquiryPosted
                }, null, 8, ["type", "vehicle"])
              ]))
            : (_unref(showQuickLookDetails))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(VehicleQuickLookDetail, {
                    vehicle: _unref(store).state.enquiryModal.vehicle,
                    showLocation: _unref(showLocation)
                  }, null, 8, ["vehicle", "showLocation"])
                ]))
              : (_unref(showReserveDetails))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(VehicleReserve, {
                      vehicle: _unref(store).state.enquiryModal.vehicle
                    }, null, 8, ["vehicle"])
                  ]))
                : (_unref(showCertifiedDetails))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                  : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})